import { render, staticRenderFns } from "./Depart.vue?vue&type=template&id=03ac5fe0&scoped=true&"
import script from "./Depart.vue?vue&type=script&lang=js&"
export * from "./Depart.vue?vue&type=script&lang=js&"
import style0 from "./Depart.vue?vue&type=style&index=0&id=03ac5fe0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ac5fe0",
  null
  
)

export default component.exports